import * as types from "../../ActionType";

const initState = {
    categories: [],
    loadingCategories: true,
    sub_categories_by_category: [],
}

const CategoryReducer = (state = initState, action) => {
    switch (action.type) {
        case types.ADD_CATEGORY:
            return { ...state, loadingCategories: true }
        case types.GET_CATEGORIES:
            return { ...state, categories: action.payload, loadingCategories: false }
        case types.GET_SUB_CATEGORIES_BY_CATEGORY:
            return { ...state, sub_categories_by_category: action.payload }
        case types.DELETE_CATEGORY:
            return { ...state }
        case types.EDIT_CATEGORY:
            return { ...state, loadingCategories: true }
        default:
            return state;
    }
};

export default CategoryReducer;
